import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Breadcrumb } from "antd";
import { Navigate, useLocation, useNavigate } from "react-router";
import Emitter from "../utils/emitter";
import { HomeContext } from "../containers/Home";
import { initialExtraMenu, initialMainMenu } from "../services/MainMenu";

function BreadcrumbComponent(props: any) {
	const context: any = useContext(HomeContext);
	const location: any = useLocation();
	const navigate = useNavigate();
	const [menuRoutes, setMenuRoutes]: any = useState<any>(null);
	const [breadCrumb, setBreadCrumb]: any = useState<any>([]);

	useEffect(() => {
		// Recursive function to flatten menu items and filter out ones with the "to" prop
		const flattenMenuItemsWithToProp = (items: any) => {
			return items.flatMap((item: any) => {
				const menuWithTo = item.to ? [{ ...item, to: item.to }] : [];
				const menuChildren = item.children
					? flattenMenuItemsWithToProp(item.children)
					: [];
				const specialChildren = item.child
					? flattenMenuItemsWithToProp(item.child)
					: [];
				return [...menuWithTo, ...menuChildren, ...specialChildren];
			});
		};

		const flatMenuItemsWithToProp = flattenMenuItemsWithToProp([
			...initialMainMenu,
			...initialExtraMenu,
		]);
		setMenuRoutes(flatMenuItemsWithToProp);
	}, [context]);

	const getBreadcrumbNameFromPath = (path: any, solo: any, index: any) => {
		const keyPathToText = (keyName: any) => {
			if (keyName)
				return keyName
					.split("-")
					.map((part: any) => part.charAt(0).toUpperCase() + part.slice(1))
					.join(" ");
			else return "undefined";
		};

		let splittedPath = path.split("/");
		if (splittedPath[1] === "projects") {
			if (index == 1 && solo != "project-settings") {
				solo = context.currentProject?.project_name;
			}
			if (index == 2 && solo != "project-settings") {
				solo = context.currentWell?.well_project_name;
			}
		}

		const route = menuRoutes.find((route: any) => route?.to?.includes(solo));
		return route ? route.propTitle : keyPathToText(solo);
	};

	const findChildRoute = (parentPath: any, currentPath: any) => {
		const parentRoute = menuRoutes.find(
			(route: any) => route.path === parentPath
		);
		if (!parentRoute || !parentRoute.children) return null;
		return parentRoute.children.find((childRoute: any) =>
			currentPath.startsWith(parentPath + childRoute.path)
		);
	};

	useEffect(() => {
		if (menuRoutes) {
			const pathSnippets = location.pathname.split("/").filter((i: any) => i);
			const breadcrumbItems = [
				{
					key: "home",
					title: "Home",
					href: "/dashboard",
					index: 1,
				},
			];
			const breadcrumbItemsAdd = pathSnippets.map(
				(slicedPath: any, index: any) => {
					const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
					const breadcrumbName = getBreadcrumbNameFromPath(
						url,
						slicedPath,
						index
					);
					if (breadcrumbName) {
						return {
							key: breadcrumbName + index,
							title: breadcrumbName,
							href: url,
							index: index + 2,
						};
					}
					return null;
				}
			);

			setBreadCrumb([...breadcrumbItems, ...breadcrumbItemsAdd]);
		}
	}, [location.pathname, menuRoutes]);

	const handleBreadCrumbNavigate = async (
		breadcrumb: any,
		position: any = null
	) => {
		try {
			await context?.handlePageChange();
			sessionStorage.removeItem("admin-tabkey");
			sessionStorage.removeItem("tabkey");
			navigate(breadcrumb.href);
		} catch {}
	};

	const itemRender = (
		currentRoute: any,
		params: any,
		items: any,
		paths: any
	) => {
		const isLast = currentRoute?.index === items.length;
		return isLast ? (
			<span>{currentRoute.title}</span>
		) : (
			<a
				onClick={() => {
					handleBreadCrumbNavigate(currentRoute);
				}}
			>
				{currentRoute.title}
			</a>
		);
	};

	return (
		<>
			<Breadcrumb
				key={"Breadcrumb"}
				items={breadCrumb}
				itemRender={itemRender}
			/>
		</>
	);
}

export default BreadcrumbComponent;
